import { render, staticRenderFns } from "./AvailableCourses.vue?vue&type=template&id=5aa3e5e0&scoped=true&lang=pug&"
import script from "./AvailableCourses.vue?vue&type=script&lang=js&"
export * from "./AvailableCourses.vue?vue&type=script&lang=js&"
import style0 from "./AvailableCourses.vue?vue&type=style&index=0&id=5aa3e5e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa3e5e0",
  null
  
)

export default component.exports